import { useState, useCallback, useEffect } from 'react';

const KEY = 'ipx-sidebar-collapsed';

export function useSidebarCollapsed() {
  const [collapsed, setCollapsedRaw] = useState(() => {
    try {
      return localStorage.getItem(KEY) === 'true';
    } catch {
      return false;
    }
  });

  const setCollapsed = useCallback((v: boolean | ((prev: boolean) => boolean)) => {
    setCollapsedRaw(prev => {
      const next = typeof v === 'function' ? v(prev) : v;
      try {
        localStorage.setItem(KEY, String(next));
      } catch {
        // ignore
      }
      return next;
    });
  }, []);

  const toggle = useCallback(() => setCollapsed(p => !p), [setCollapsed]);

  // keyboard shortcut: [ to toggle
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === '[' && !e.ctrlKey && !e.metaKey && !e.altKey) {
        const tag = (e.target as HTMLElement)?.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        toggle();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [toggle]);

  return { collapsed, setCollapsed, toggle } as const;
}
